import type { GallerySnapshot } from "@roboscientist/contracts";
import { englishGallerySnapshot } from "./galleryEnglish.js";

const sipaiSnapshotId = "01a023f6-62ca-75f3-ba19-a0fd9f76abb0@2026-08-31T12:37:12.527071Z";
const qwenSnapshotId = "01a07af7-8a83-7352-99c1-6c00c09eeb9a@2026-09-14T09:48:17.641Z";

/** Apply the requested display order without changing export dates or saved evidence. */
export function galleryDisplaySnapshots(snapshots: readonly GallerySnapshot[]): GallerySnapshot[] {
  const display = snapshots.map(englishGallerySnapshot);
  const sipai = display.findIndex((snapshot) => snapshot.snapshot.id === sipaiSnapshotId);
  const qwen = display.findIndex((snapshot) => snapshot.snapshot.id === qwenSnapshotId);
  if (qwen >= 0 && sipai > qwen) {
    [display[sipai], display[qwen]] = [display[qwen]!, display[sipai]!];
  }
  return display;
}
